import AjaxSubmit from './ajax-submit'
import ReturnSubmit from './return-submit'
import CheckOutSubmit from './check-out-submit'
import ProfileSubmit from './profile-submit'
import AuthSubmit from './auth-submit'
import AgentProfileSubmit from './agent-profile-submit'
import SpaCheckoutSubmit from './spa-checkout-submit'

export {
  AjaxSubmit,
  ReturnSubmit,
  CheckOutSubmit,
  ProfileSubmit,
  AuthSubmit,
  AgentProfileSubmit,
  SpaCheckoutSubmit
}
